import { isNullOrEmpty } from "./isNullOrEmpty";
import { getFetch } from "./getFetch";
import i18next from "i18next";
import { inicializarInternacionalizacao } from "../localizacao/selectCidades/selectCidades";


export async function selectCidades(url, id, $element, selectedValue) {
    inicializarInternacionalizacao()
    if (isNullOrEmpty(id) || id == '0') {
        $element.innerHTML = '<option value=""></option>';
        return;
    }
    $element.innerHTML = `<option value="">${i18next.t('SelectCidadeGenericoCarregando')}</option>`;

    const callbackSucesso = function (resultado) {
        let html = [];
        html.push(`<option value="">${i18next.t('SelectCidadeGenericoPlaceholder')}</option>`);

        for (let i = 0; i < resultado.dados.length; i++) {
            html.push('<option value="' + resultado.dados[i].id + '"' + ((selectedValue == resultado.dados[i].id || selectedValue == resultado.dados[i].sigla) ? ' selected ' : '') + '>' + resultado.dados[i].nome + '</option>');
        }
        $element.innerHTML = html.join('');

        if (url == 'estados') {
            if (!isNullOrEmpty(selectedValue)) {
                $element.dispatchEvent(new Event('change'));
            }
            document.getElementById('cidadeID').innerHTML = `<option value="">${i18next.t('SelectCidadeGenericoEstadoObrigatorio')}</option>`;
        }
    };
    const callbackErro = function (resultado) {
    };

    await getFetch(`${URL_API}variaveis/${url}/${id}`, callbackSucesso, callbackErro);
}
